import { useForm } from "react-hook-form"
import CustomAccordion from "../../../../components/ui/materialui/customAccordion"
import { ValidacionDto } from "../models/validacionDto"
import { useEffect } from "react"
import { Grid2 } from "@mui/material"
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber"

interface IProps{
    validacion: ValidacionDto
}

export const ValidacionesTableForm = ({validacion} : IProps) => {

    const { control, setValue } = useForm<ValidacionDto>({})

    useEffect(() => {
        if (validacion){
            setValue("sumaAmortizacion", validacion.sumaAmortizacion)
            setValue("sumaInteresCapital", validacion.sumaInteresCapital)
            setValue("sumaMontoCuota", validacion.sumaMontoCuota)
            setValue("diferenciasSuma", validacion.diferenciasSuma)
        }
    }, [validacion])
    
    return (
        <CustomAccordion
            title='Validaciones'
            expandedDefault
        >
            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"sumaAmortizacion"}
                        control={control}
                        decimales={5}
                        label="Suma amortización"
                        readonly
                        disabled                                           
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"sumaInteresCapital"}
                        control={control}
                        decimales={5}
                        label="Suma interés y capital (a)"
                        readonly
                        disabled                                           
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"sumaMontoCuota"}
                        control={control}
                        decimales={5}
                        label="Suma monto cuota (b)"
                        readonly
                        disabled                                           
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        name={"diferenciasSuma"}
                        control={control}
                        decimales={5}
                        label="Diferencias suma (a-b)"
                        readonly
                        disabled                                           
                    />
                </Grid2>
            </Grid2>
        </CustomAccordion>
    )
}